// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconRmsTopographyAcquisition_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M24 0V10H22V2H21.6239C21.787 3.61903 21.27 5.358 20.2099 7H17.7706C19.1843 5.36078 19.887 3.56903 19.6162 2H13.84C13.9449 2.32311 14 2.65753 14 3C14 5.76142 10.4183 8 6 8C4.54285 8 3.17669 7.75651 2 7.33109V10.5264C2.94056 11.3865 4.34743 11.8865 6 11.9997V13.961C4.49985 13.8646 3.1325 13.5077 2 12.9076V22H4.86397C5.16859 21.3887 5.5495 20.7845 6 20.1979V24L0 24V0H24ZM11.6586 2H2V5.23611C3.06151 5.71115 4.46329 6 6 6C9.31371 6 12 4.65685 12 3C12 2.64936 11.8797 2.31278 11.6586 2Z" class="svg-bg"/>
  <path d="M13 9H19L20 11H12L13 9Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M19 18C19 19.6569 17.6569 21 16 21C14.3431 21 13 19.6569 13 18C13 16.3431 14.3431 15 16 15C17.6569 15 19 16.3431 19 18ZM16.9992 18.0406C16.9779 18.574 16.5387 19 16 19C15.5771 19 15.2154 18.7374 15.0693 18.3664C15.0246 18.2529 15 18.1293 15 18C15 17.4477 15.4477 17 16 17C16.5523 17 17 17.4477 17 18C17 18.0136 16.9997 18.0271 16.9992 18.0406Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M24 12H8V24H24V12ZM22 14H10V22H22V14Z" class="svg-bg"/>
</svg>
`;
/**
 * IconRmsTopographyAcquisition is a generated icon component.
 */
let IconRmsTopographyAcquisition = IconRmsTopographyAcquisition_1 = class IconRmsTopographyAcquisition extends IconBaseElement {
    render() {
        return html `${IconRmsTopographyAcquisition_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconRmsTopographyAcquisition.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconRmsTopographyAcquisition = IconRmsTopographyAcquisition_1 = __decorate([
    customElement('zui-icon-rms-topography-acquisition')
], IconRmsTopographyAcquisition);
export { IconRmsTopographyAcquisition };
